import BaseState from 'Engine/base/states/BaseState';
import EntryPoint from 'Engine/EntryPoint';
import GameModel from '../models/GameModel';
import gameConfig from '../configs/gameConfig';
import ServerManager from '../api/ServerManager';
import SpinTimeManager from 'Engine/base/spinTime/SpinTimeManager';

export default class RequestRollingState extends BaseState {
  constructor(stateData) {
    super(stateData);

    GameModel.startRequestTime = 0;
  }

  async start() {
    SpinTimeManager.start();
    GameModel.startRequestTime = Date.now();
    OPWrapperService.realityCheck.blockedRealityCheck = true;
    if (!EntryPoint.GameModel.isFreeSpinsMode) {
      OPWrapperService.freeBetsController.decreaseFreeBets();
      OPWrapperService.ControllerStatistic.bet = EntryPoint.GameModel.bet;
    }
    EntryPoint.GameModel.lastBetAmount = EntryPoint.GameModel.bet;
    if (!OPWrapperService.freeBetsController.isActive && !EntryPoint.GameModel.freespinsEnabled) {
      EntryPoint.GameModel.balance = EntryPoint.GameModel.balance - EntryPoint.GameModel.bet;
    }
    super.start();
    await ServerManager.onStartSpin();
    this.complete();
  }

  onEnd() {
    super.onEnd();
  }

  stop() {
    EntryPoint.GameSettings.quickStop = true;
  }
}
